import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import React, { PropsWithChildren, useState } from "react";

interface OwnProps {
    product: any;
}

const SearchAutoCompleteProductAction: React.FC<PropsWithChildren<OwnProps>> = ({ product, children }) => {
    const [productInfoState, setProductInfoState] = useState({
        productId: product.id,
        qtyOrdered: product.qtyOrdered,
        unitOfMeasure: "",
        productDetailPath: product.url,
    });

    const onQtyChange = (qty: number) => {
        setProductInfoState({
            ...productInfoState,
            qtyOrdered: qty,
        });
    };

    const productContext: ProductContextModel = {
        product: {
            ...product,
        },
        productInfo: productInfoState,
        onQtyOrderedChanged: onQtyChange,
    };

    return <ProductContext.Provider value={productContext}>{children}</ProductContext.Provider>;
};

export default SearchAutoCompleteProductAction;
